const state = {
  dictList: [],
};

const mutations = {
  setDictList(state, list) {
    state.dictList = [];
    list.forEach(dict => {
      state.dictList.push(dict);
    });
  },
};

const actions = {
  init({ commit, state }, {dictList}) {
    commit('setDictList', dictList);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js